export class InfoBookingTicket {
    maLichChieu = 0;
    danhSachVe = [];
    taiKhoanNguoiDung = "";
    diaChitenPhim = "";
    tenCumRap = "";
    diaChi = "";
    timeBooking= null
   
}